import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface TimeUtilization {
  currentStatus: string;
  workingHours: number;
  canPunchOut: string;
  breakTime: number;
  overtime?: number;
  punchInTime: string;
  workingPercentage?: number;
  activities: [
    {
      id: string;
      name: string;
      duration: number;
      status: string;
      time: string;
      type: string;
    }
  ];
}

export type TimeUtilizationResponse = {
  success: boolean;
  message: string;
  data: TimeUtilization;
};

const getTimeUtilization = async (userId?: string): Promise<TimeUtilizationResponse> => {
  const params = new URLSearchParams();
  if (userId) {
    params.append('userId', userId);
  }
  return (
    await customAxios.get<TimeUtilizationResponse>(
      `/attendance/dashboard/time-utilization${params.toString() ? `?${params.toString()}` : ''}`
    )
  ).data;
};

export const useGetTimeUtilization = (userId?: string) =>
  useQuery<TimeUtilizationResponse, AxiosError>(
    ["attendance", userId],
    () => getTimeUtilization(userId),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Time Utilization",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load time utilization",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
